import {CommandStrategy, SubmenuType} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import {HandController} from '../../../../../controllers/HandController';
import {CardSelector} from '../../../../../controllers/CardSelector';
import {DynamicData} from '../../../../../data/DynamicData';

export class TakeStackCardsInHandCommandStarategy extends CommandStrategy
{
    private stack: Stack | undefined;

    constructor() {
        super({
            iconId: PieMenuIcons.HND,
            hint: 'Take X cards\nin hand',
            hasSubmenu: true,
            submenuType: SubmenuType.NUMBER
        });
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        this.stack = stack!;
        return CardSelector.selectedCards.length == 0 && !!stack && DynamicData.settings.canTableTakeCards;
    }

    execute(commandIndex: number): void {
        if (this.stack!.activeData.locked) {
            return;
        }
        HandController.moveXCardsOfStackToHand(this.stack!, commandIndex + 1);
    }

    getTier2CommandsCount(): number {
        return Math.min(20, this.stack!.activeData.cards.length);
    }
}
